interface StorytellingVideoElements {
    video: HTMLVideoElement | null;
    pauseButton: HTMLButtonElement | null;
    muteButton: HTMLButtonElement | null;
  }
  
  class StorytellingVideo extends HTMLElement implements StorytellingVideoElements {
    video: HTMLVideoElement | null = null;
    pauseButton: HTMLButtonElement | null = null;
    muteButton: HTMLButtonElement | null = null;
    playedIcon: SVGElement | null = null;
    pausedIcon: SVGElement | null = null;
    mutedIcon: SVGElement | null = null;
    unmutedIcon: SVGElement | null = null;
  
    constructor() {
        super();
        this.video = this.querySelector<HTMLVideoElement>('video');
        this.pauseButton = this.querySelector<HTMLButtonElement>('.js-pause-button');
        this.muteButton = this.querySelector<HTMLButtonElement>('.js-mute-button');
  
        this.playedIcon = this.querySelector<SVGElement>('.played-icon');
        this.pausedIcon = this.querySelector<SVGElement>('.paused-icon');
        this.mutedIcon = this.querySelector<SVGElement>('.muted-icon');
        this.unmutedIcon = this.querySelector<SVGElement>('.unmuted-icon');
    }
  
    connectedCallback(): void {
      this.pauseButton?.addEventListener('click', () => this.toggleVideoPlay());
      this.muteButton?.addEventListener('click', () => this.toggleMute());
    }
  
    toggleVideoPlay(): void {
      if (!this.video) return;
      
      if (this.video.paused) {
        this.video.play();
        this.changePlayIcon();
      } else {
        this.video.pause();
        this.changePlayIcon();
      }
    }
  
    changePlayIcon(): void {
      if (!this.playedIcon || !this.pausedIcon) return;
  
      if (this.video?.paused) {
          this.playedIcon.ariaHidden = 'false';
          this.pausedIcon.ariaHidden = 'true';
      } else {
          this.playedIcon.ariaHidden = 'true';
          this.pausedIcon.ariaHidden = 'false';
      }
    }
  
    toggleMute(): void {
      if (!this.video) return;
      this.video.muted = !this.video.muted;
      this.changeMuteIcon();
    }
  
    changeMuteIcon(): void {
      if (!this.mutedIcon || !this.unmutedIcon) return;
  
      if (this.video?.muted) {
          this.mutedIcon.ariaHidden = 'false';
          this.unmutedIcon.ariaHidden = 'true';
      } else {
          this.mutedIcon.ariaHidden = 'true';
          this.unmutedIcon.ariaHidden = 'false';
      }
    }
  
    disconnectCallback(): void {
      this.pauseButton?.removeEventListener('click', () => this.toggleVideoPlay());
      this.muteButton?.removeEventListener('click', () => this.toggleMute());
    }
  }
  
  customElements.define('storytelling-video', StorytellingVideo);